import React from "react";
import styled from "@emotion/styled";
import {graphql, useStaticQuery} from "gatsby";
import mediaqueries from "@styles/media";

import Section from "@components/Section";
import SocialLinks from "@components/SocialLinks";
import EmailSubscriptionForm from "@components/EmailSubscriptionForm";
import FooterLinks from "@components/Navigation/Navigation.Footer.Links";
import FooterCopyright from "@components/Navigation/Navigation.Footer.Copyright";

const siteQuery = graphql`
  {
    allSite {
      edges {
        node {
          siteMetadata {
            name
            social {
              url
              name
            }
          }
        }
      }
    }
    allMdx(
      sort: { fields: frontmatter___date, order: ASC }
      filter: { frontmatter: { date: { ne: null } } }
    ) {
      edges {
        node {
          frontmatter {
            date
          }
        }
      }
    }
  }
`;

const Footer: React.FC<{}> = () => {
  return (
    <>
      <FooterGradient />
      <Section narrow>
        <FooterContainer>
          <FooterContentContainer>
            <FooterLinks />
            <FooterSocial />
          </FooterContentContainer>
          <FooterCopyright />
        </FooterContainer>
      </Section>
    </>
  );
};

const FooterSocial: React.FC<{}> = () => {
  const results = useStaticQuery(siteQuery);
  const { social } = results.allSite.edges[0].node.siteMetadata;
  return (
    <>
      <FooterSocialContainer>
        <FooterSocialTitle>
          We send really nice emails
        </FooterSocialTitle>
        <EmailSubscriptionFormContainer>
          <EmailSubscriptionForm />
        </EmailSubscriptionFormContainer>
        <div>
          <SocialLinks links={social} />
        </div>
      </FooterSocialContainer>
    </>
  );
};

const FooterGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 600px;
  z-index: 0;
  pointer-events: none;
  background: #000000;
  ${mediaqueries.phablet`
    height: 700px;
  `}
`;

const HoritzontalRule = styled.div`
  position: relative;
  margin: 140px auto 114px;
  border-bottom: 1px solid ${p => p.theme.colors.horizontalRule};

  ${mediaqueries.tablet`
    margin: 60px auto;
  `}

  ${mediaqueries.phablet`
    display: none;
  `}
`;

const FooterContainer = styled.div`
  position: relative;
  padding-bottom: 52px;
  color: ${p => p.theme.colors.grey};
  margin-top: 200px;

  ${mediaqueries.tablet`
    padding-bottom: 32px;
  `}

  ${mediaqueries.phablet`
    padding-bottom: 20px;
    margin-top: 100px;
  `}
`;

const FooterContentContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;

  ${mediaqueries.tablet`
    flex-direction: column;
  `}
`;


const FooterSocialContainer = styled.div`
  ${mediaqueries.phablet`
    padding-top: 50px;
  `}
`;

const FooterSocialTitle = styled.div`
  font-weight: 400;
  font-size: 30px;
  line-height: 165%;
  letter-spacing: -.05em;
  color: #ffffff;

  ${mediaqueries.desktop`
    font-size: 20px;
  `}
  
  ${mediaqueries.phablet`
    font-size: 20px;
  `}
`;

const EmailSubscriptionFormContainer = styled.div`
  padding-top: 14px;
  padding-bottom: 30px;
`;

export default Footer;
